<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>订单状态：</label>
                <el-select v-model="search_Obj.f_status" clearable placeholder="请选择">
                    <el-option v-for="item in enuObj('order_status')" :key="'order_status'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>订单号：</label>
                <el-input v-model="search_Obj.f_sn" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>收件人：</label>
                <el-input v-model="search_Obj.f_receiver" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>手机号：</label>
                <el-input v-model="search_Obj.f_receiver_phone" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>支付时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="sn" label="订单编号" sortable="custom" width="200"></el-table-column>
                <el-table-column prop="status" label="订单状态" sortable="custom" width="110px">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.status, "order_status") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="paytime" label="支付时间" sortable="custom"></el-table-column>
                <el-table-column prop="pay_online" label="现金支付" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="pay_balance" label="积分支付" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="member_id" label="会员ID" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称" sortable="custom"></el-table-column>
                <el-table-column prop="receiver" label="收货人" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="receiver_phone" label="收货人电话" sortable="custom" width="120"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="1000px"
            :id="model_id"
            title="查看订单"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
        <ImportExpress
            width="600px"
            title="导入物流信息"
            :isshow="importexpressshow"
            @on-close="closeImportExpressDialog"
            @on-imp-ok="impExpressOk">
        </ImportExpress>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import ImportExpress from "./importexpress"
import listutil from "@/libs/listutil"
import { exportOrder } from '@/api/orderdao'

export default {
    name: 'orderList',
    mixins: [listutil],
    components: {Edit, Info, ImportExpress, Btns, LabBtns},
    data() {
        return {
            m_name: '订单',
            menu_id: 7500,
            list_url: "/api/admin/order/list",
            search_Obj: {
                f_sn: '',
                f_status: '',
                f_receiver: '',
                f_receiver_phone: '',
                f_paytime_s_date: '',
                f_paytime_e_date: '',
            },
            del_Obj:{
                url:'/api/admin/order/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['order_status', 'pay_type'],
            dateRange: '',
            importexpressshow: false,
        };
    },
    methods: {
        closeInfoDialog() {
            this.infoshow = false
            this.getListData()
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_paytime_s_date = val[0]
                this.search_Obj.f_paytime_e_date = val[1]
            }else{
                this.search_Obj.f_paytime_s_date = ''
                this.search_Obj.f_paytime_e_date = ''
            }
        },
        export(){
            exportOrder(this.search_Obj.f_status, this.search_Obj.f_sn, this.search_Obj.f_receiver, this.search_Obj.f_receiver_phone, this.search_Obj.f_paytime_s_date, this.search_Obj.f_paytime_e_date).then(res=>{
                if(res.code ==1){
                    setTimeout(() => {
                        window.open(res.data+"")
                    }, 500);
                }else {
                    this.$msg(res.msg)
                }
            })
        },
        importExpress(){
            this.importexpressshow = true
        },
        impExpressOk(){
            this.importexpressshow = false
            this.getListData()
        },
        closeImportExpressDialog(){
            this.importexpressshow = false
        },
    }
};
</script>